import { render, staticRenderFns } from "./numberElement.vue?vue&type=template&id=026b6d5d&scoped=true"
import script from "./numberElement.vue?vue&type=script&lang=js"
export * from "./numberElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026b6d5d",
  null
  
)

export default component.exports